import "../chunk-D57E6H3M.mjs";

// src/hooks/useEntranceStagger.ts
import { useState } from "react";
var STAGGER_CAP = "240ms";
function staggerDelay(index, offsetMs = 0) {
  const step = `min(${index} * var(--bs-motion-surface-stagger, 40ms), ${STAGGER_CAP})`;
  return offsetMs > 0 ? `calc(${offsetMs}ms + ${step})` : `calc(${step})`;
}
function useEntranceStagger(keys, skip) {
  const [placed] = useState(() => /* @__PURE__ */ new Map());
  let next = 0;
  for (const key of keys) {
    if (placed.has(key) || skip?.has(key)) continue;
    placed.set(key, next++);
  }
  return (key) => placed.get(key) ?? 0;
}
export {
  staggerDelay,
  useEntranceStagger
};
//# sourceMappingURL=useEntranceStagger.mjs.map